import { createDomain } from 'effector';

const domain = createDomain('set-virtual-licence-quota-list-modal');

if (process.env.NODE_ENV === 'development') {
    // @ts-ignore
    import('effector-logger/attach').then((module) => module.attachLogger(domain));
}

export default domain;
